/**
 * Documentation:
 * https://stamps.atlassian.net/wiki/spaces/RnD/pages/1078919319/LabelPreview+Component
 */

import { Carrier } from '../carriers';
import SheetType from './SheetType.enum';
import NetStampSeries from './NetStampSeries.enum';

export default Object.freeze([
	{
		sheet: SheetType.NetStamps,
		series: [
			/*
				Traditional
				The 2-series and A-series NetStamps.
				25 labels (5 x 5) on letter sized sheet with full 40 x 40 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.Traditional,
				pattern: /^2\d{8}$|^A\d{5}$/i,
				numRows: 5,
				numCols: 5,
				width: 40,
				height: 55,
			},
			/*
				Standard
				The C-series and V-series NetStamps.
				25 labels (5 x 5) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.Standard,
				pattern: /^[CV]\d{5}$/i,
				numRows: 5,
				numCols: 5,
				width: 40,
				height: 40,
			},
			/*
				Promotional
				The 9-series NetStamps promo paper.
				10 labels (5 x 2) on letter sized sheet with full 40 x 40 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.Promotional,
				pattern: /^9\d{8}$/i,
				numRows: 2,
				numCols: 5,
				width: 40,
				height: 55,
			},
			/*
				Themed
				The K-series themed NetStamps.
				24 labels (3 x 8) on letter sized sheet with IBI-Lite 12 x 36 DataMatrix barcode.
			*/
			{
				type: NetStampSeries.Themed,
				pattern: /^K\d{5}$/i,
				numRows: 8,
				numCols: 3,
				width: 66,
				height: 30,
			},
			/*
				PhotoLandscape
				The L-series and ML-series photo NetStamps in landscape orientation.
				24 labels (3 x 8) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.PhotoLandscape,
				pattern: /^ML\d{4}$|^L\d{5}$/i,
				numRows: 8,
				numCols: 3,
				width: 70,
				height: 30,
			},
			/*
				PhotoPortrait
				The P-series and MP-series photo NetStamps in portrait orientation.
				24 labels (3 x 8) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.PhotoPortrait,
				pattern: /^MP\d{4}$|^P\d{5}$/i,
				numRows: 8,
				numCols: 3,
				width: 70,
				height: 30,
			},
			/*
				ReturnAddress
				The R-series NetStamps with return address labels.
				20 labels (4 x 5) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.ReturnAddress,
				pattern: /^R\d{5}$/i,
				numRows: 5,
				numCols: 4,
				width: 60,
				height: 64,
			},
			/*
				Alternate
				The B-series NetStamps.
				25 labels (5 x 5) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.Alternate,
				pattern: /^B\d{5}$/i,
				numRows: 5,
				numCols: 5,
				width: 41,
				height: 41,
			},

			/*
				PhotoLandscapeHS
				The H-series NetStamps for HP in landscape orientation.
				24 labels (3 x 8) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.PhotoLandscapeHs,
				pattern: /^H\d{5}$/i,
				numRows: 8,
				numCols: 3,
				width: 70,
				height: 30,
			},
			/*
				RollTypeSorD
				The S or D series NetStamps.
				From 1 to 25 labels on a roll with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.RollTypeSorD,
				pattern: /^S\d{5}$|D\d{5}$/i,
				numRows: 3,
				numCols: 1,
			},
			/*
				PromoPaper20
				The L-series photo NetStamps in landscape orientation.
				9 labels (3 x 3) on letter sized sheet with IBI-Lite 12 x 36 Data Matrix barcode.
			*/
			{
				type: NetStampSeries.PromoPaper20,
				pattern: /^WN\d{4}$|^DM\d{4}$/i,
				numRows: 3,
				numCols: 3,
				width: 70,
				height: 30,
			},
		],
	},
	{
		sheet: SheetType.ShippingLabel,
		series: [
			{
				type: Carrier.USPS,
				numRows: 1,
				numCols: 2,
				width: 203,
				height: 320,
			},
			{
				type: Carrier.UPS,
				numRows: 1,
				numCols: 2,
				width: 200,
				height: 300,
			},
			{
				type: Carrier.DHLExpress,
				numRows: 1,
				numCols: 2,
				width: 200,
				height: 300,
			},
			{
				type: Carrier.GlobalPost,
				numRows: 1,
				numCols: 2,
				width: 200,
				height: 300,
			},
			{
				type: Carrier.FedEx,
				numRows: 1,
				numCols: 2,
				width: 200,
				height: 300,
			},
		],
	},
	{
		sheet: SheetType.Envelope,
		series: [
			{
				type: '6',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '7',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '9',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '10',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '11',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '12',
				numRows: 1,
				numCols: 1,
			},
			{
				type: 'a2',
				numRows: 1,
				numCols: 1,
			},
			{
				type: 'a9',
				numRows: 1,
				numCols: 1,
			},
		],
	},
	{
		sheet: SheetType.CertifiedMail,
		series: [
			{
				type: '3610',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '3710',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '3910',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '3930',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '3810',
				numRows: 1,
				numCols: 1,
			},
			{
				type: '3830',
				numRows: 1,
				numCols: 1,
			},
		],
	},
	{
		sheet: SheetType.Roll,
		series: [
			{
				type: Carrier.USPS,
				numRows: 1,
				numCols: 1,
				width: 203,
				height: 320,
			},
			{
				type: Carrier.UPS,
				numRows: 1,
				numCols: 1,
				width: 200,
				height: 300,
			},
			{
				type: Carrier.DHLExpress,
				numRows: 1,
				numCols: 1,
				width: 200,
				height: 300,
			},
			{
				type: Carrier.GlobalPost,
				numRows: 1,
				numCols: 1,
				width: 200,
				height: 300,
			},
			{
				type: Carrier.FedEx,
				numRows: 1,
				numCols: 1,
				width: 200,
				height: 300,
			},
		],
	},
]);
